<template>
  <v-card class="bg-pwt_snow" elevation="0" flat>
    <v-card-title class="text-h5"> My fleet </v-card-title>
    <v-card flat class="bg-pwt_snow">
      <v-card-title>
        <v-row no-gutters align="center">
          <span> Fleet vehicles </span>
          <v-spacer />
          <v-btn v-if="smAndDown" icon @click="() => emit('view-vehicles')">
            <v-icon color="grey-lighten-1">mdi-dots-vertical</v-icon>
          </v-btn>
          <TextBtn v-else @click="() => emit('view-vehicles')"> View all </TextBtn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <span v-if="!vehicleList.length" class="py-5">
          You don't have any vehicles in your fleet
        </span>
        <v-row no-gutters v-else>
          <v-card
            flat
            v-for="(vehicle, index) in vehicleList"
            :key="'vehicle-' + index"
            :style="smAndDown ? 'width: 100%' : 'width: 50%'"
            class="pa-md-1 py-1"
          >
            <VehicleListCard
              :vehicle="vehicle"
              @click="() => emit('view-vehicle', vehicle.localId)"
              :selected="false"
            />
          </v-card>
        </v-row>
        <v-row no-gutters v-if="vehicleList.length">
          <v-spacer />
          <ElevatedBtn @click="showBookingDialog = true" class="mt-3">
            Book fleet vehicles
          </ElevatedBtn>
        </v-row>
        <GenericDialog :activator="showBookingDialog" @close="showBookingDialog = false" small>
          <v-card-title> Book fleet vehicles </v-card-title>
          <v-card-subtitle>Premium feature</v-card-subtitle>
          <v-card-text>
            Please contact PowerTrip to discuss unlocking premium features
          </v-card-text>
        </GenericDialog>
      </v-card-text>
    </v-card>
    <v-card flat class="bg-pwt_snow">
      <v-card-title>
        <v-row no-gutters align="center">
          <span> Fleet locations </span>
          <v-spacer />
          <TextBtn v-if="mdAndUp" @click="() => emit('view-locations')"> View all </TextBtn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <span v-if="!fleetLocationsList.length" class="py-5">
          You don't have any saved locations
        </span>

        <v-row no-gutters>
          <v-col
            cols="12"
            md="6"
            v-for="(location, index) in fleetLocationsList"
            :key="'location-card-' + index"
            :class="index % 2 === 0 ? 'pr-0  pr-md-2' : 'pl-0  pl-md-2'"
            class="mb-3"
          >
            <LocationDisplayCard
              :location="location"
              @click="() => navigateToLocationDetails(location)"
            />
          </v-col>
        </v-row>
        <ElevatedBlockBtn v-if="smAndDown" class="mt-3" @click="() => emit('view-locations')">
          See all fleet locations
        </ElevatedBlockBtn>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script lang="ts" setup>
import FavouriteLocation from '@/classes/favouriteLocation'
import Vehicle from '@/classes/vehicle_classes/vehicle'
import LocationDisplayCard from '@/components/location-manager/dashboard-components/LocationDisplayCard.vue'
import { GettersTypes, MutationTypes, type State } from '@/store/store_types'
import { computed, ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'
import GenericDialog from '../../dialog-wrappers/GenericDialog.vue'
import ElevatedBlockBtn from '../../ui-elements/buttons/ElevatedBlockBtn.vue'
import ElevatedBtn from '../../ui-elements/buttons/ElevatedBtn.vue'
import TextBtn from '../../ui-elements/buttons/TextBtn.vue'
import VehicleListCard from '../../vehicles/VehicleListCard.vue'

const emit = defineEmits<{
  (e: 'view-vehicle', id: string | undefined): void
  (e: 'view-vehicles'): void
  (e: 'view-locations'): void
}>()

const store = useStore<State>()
const { smAndDown, mdAndUp } = useDisplay()

const showBookingDialog = ref(false)

const vehicleList = computed<Vehicle[]>(() => {
  const returnList: Vehicle[] = []
  const fullList = store.getters[GettersTypes.connectedVehicles] as Vehicle[]

  fullList.forEach((vehicle, index) => {
    if (index < (smAndDown ? 3 : 4)) returnList.push(vehicle)
  })

  return returnList
})
const fleetLocationsList = computed<FavouriteLocation[]>(() => {
  const unfilteredList = store.state.favLocations
  return unfilteredList.filter((location) => location.visibility !== 'private').slice(0,4)
})

const navigateToLocationDetails = (location: FavouriteLocation) => {
  store.commit(MutationTypes.setSelectedFavLocation, location)
  store.commit(MutationTypes.setDashboardDialogContent, 'fleet-location-details')
}
</script>
